import { message, Modal, Space } from "antd";
import { PlusIcon } from "../../admin/Icons";
import Overlay from "../Overlay";
import wrap from "../../utils/wrap";
import Template from "./Template";
import { usePrefs } from "../../utils/Prefs";
import Save from "../Save";
import { useEffect, useState } from "react";
import { apiCall } from "../../utils/Api";
import { useTemplate } from "../../utils/Template";

export default function Templates(props) {

    const [prefs, setPrefs] = usePrefs();
    const [template, setTemplate] = useTemplate();
    const { templates = [], setTemplates = () => { }, data = {}, setData = () => { }, changed = false, view = "" } = props;

    const getTemplates = (_switch = false, _force = false) => {

        if(changed === true && !_force){
            return; 
        }
        apiCall("site_content/getTemplates", {}, (_status, _result) => {
            if (_status) {
                setTemplates(_result);
                if (_switch) {
                    let _template = _result.find(item => item.id === _switch);
                    setPrefs({ ...prefs, "changed": false })
                    setTemplate(_template);
                }
            } else {
                message.error(_result.error);
            }
        })
    }
    useEffect(getTemplates, [changed])




    // [TODO] Somehow save this... session maybe? 
    const switchTemplate = (_id) => {

        if (prefs.changed) {
            Modal.confirm({
                title: "Discard changes?",
                content: <>Switching your template without saving will discard any changes you've made.</>,
                onOk: () => {
                    getTemplates(_id, true);
                }
            })
        } else {
            getTemplates(_id)
        }
    }

    const deleteTemplate = (_id, callback = () => { }) => {
        apiCall("site_content/deleteTemplate", { id: _id }, (_status, _result) => {
            if (_status) {
                setTemplates(_result);
            } else {
                message.error(_result.error)
            }
            callback();
        })
    }

    const createEditTemplate = (_data, _is_new, callback = () => { }) => {

        let _template = { ...template };
        _template.name = _data.name;

        if (_is_new) {
            // clone template   
            delete _template.id;
            _template.is_active = false;
        }

        
        apiCall("site_content/setTemplate", {
            ..._template,
            colours: JSON.stringify(_template.colours),
            gradients: JSON.stringify(_template.gradients),
            buttons: JSON.stringify(_template.buttons),
            texts: JSON.stringify(_template.texts),
            fonts: JSON.stringify(_template.fonts),
            links: JSON.stringify(_template.links)

        }, (_status, _result) => {
            if (_status) {
                getTemplates();
            } else {
                message.error(_result.error)
            }
            callback();
        })
    }




    const save = (_data, _is_new = false, callback = () => { }) => {
        let _templates = [...templates];
        if (_is_new) {
            _templates.push({_data});
            setData({ ...data, "templates": _templates });
            setPrefs({ ...prefs, "changed": true });
            callback();
            return;
        } else {
            let _index = _templates.findIndex(item => item.id == _data.id);
            if (_index > -1) {
                _templates[_index] = _data;
                setData({ ...data, "templates": _templates });
                setPrefs({ ...prefs, "changed": true });
                callback();
            } else {
                message.error("There was an error");
            }
        }
    }

    const saveTemplate = (_id) => {
        let _templates = [...templates];
        _templates.forEach(item => {
            if (item.id === _id) {
                item.selected = true;
            } else {
                item.selected = false;
            }
        })
        setData({ ...data, "templates": _templates })
    }

    const set = (_id) => {
        if (changed) {
            Modal.confirm({
                title: "Save changes?",
                content: "Loading a new template will discard your current changes.",
                onOk: () => {
                    message.success("Changes saved! (fake message)");
                    setPrefs({ ...prefs, "changed": false });
                    saveTemplate(_id);
                },
                onCancel: () => {
                    message.warn("Changes not saved! (fake message)");
                    setPrefs({ ...prefs, "changed": false });
                    saveTemplate(_id);
                }
            });
        } else {
            saveTemplate(_id);
        }
    }

    const drawHeader = () => {
        return (
            <Overlay width="300px" component={<Template save={createEditTemplate} is_new />}><wrap.tags color="#1890ff"><PlusIcon /> <small>New</small></wrap.tags></Overlay>
        )
    }

    const drawTemplates = () => {
        return (
            <div>
                {templates.map(item => {
                    return (<Template setTemplates={setTemplates} templates={templates} key={item.id} selected={(template.id === item.id)} changed={changed} save={createEditTemplate} set={switchTemplate} remove={deleteTemplate} data={item} />)
                })}
            </div>
        )
    }

    switch (view) {
        case "header":
            return drawHeader();
        default: return drawTemplates();
    }

}

